import { Button } from "../../../../core/Button.js";
import { buttonStyles } from "../../../../core/Button.styles.js";
import { Panel } from "../../../../core/Panel.js";
import { Slider } from "../../../../core/Slider.js";
import { Text } from "../../../../core/Text.js";
import { Amount } from "../../../../domain/Amount.js";
import { AppLink } from "../../../../foundations/AppLink.js";
import { MobileActionBar } from "../../../../patterns/MobileBars.js";
import type { ForgeSummaryContent } from "../../forgeContent.js";

/**
 * Step 5: the creator's cut, the price it makes, and the submit (13 · Exchange, Checkout's order
 * summary). On phones the price and submit also ride in the action bar, as the checkout's do.
 */
export function ForgeSummary({
  step,
  title,
  currency,
  cut,
  price,
  submit,
  cancel,
}: ForgeSummaryContent) {
  const submitButton = (fullWidth: boolean) => (
    <Button
      variant="brand"
      size="lg"
      fullWidth={fullWidth}
      disabled={submit.disabled}
      loading={submit.busy}
      onClick={submit.onSubmit}
    >
      {submit.label}
    </Button>
  );
  return (
    <>
      <Panel size="sm" title={title} eyebrow={step}>
        {cut && (
          <div className="flex flex-col gap-2">
            <Slider
              label={cut.label}
              value={cut.value}
              min={0}
              max={cut.max}
              step={cut.step}
              format={cut.format}
              onValueChange={cut.onChange}
            />
            <Text variant="body-b3" tone="secondary">
              {cut.earnings.before}{" "}
              <Amount
                cents={cut.earnings.cents}
                currency={currency}
                size="meta"
                className="text-text-primary"
              />{" "}
              {cut.earnings.after}
            </Text>
          </div>
        )}
        <div className="flex items-baseline justify-between gap-3 border-t border-border-subtle pt-4">
          <Text as="span" variant="body-b1" tone="secondary">
            {price.label}
          </Text>
          <Amount cents={price.cents} currency={currency} size="lg" className="text-text-primary" />
        </div>
        <div className="flex flex-col gap-2">
          {/* On phones the action bar carries the submit. */}
          <div className="contents max-md:hidden">{submitButton(true)}</div>
          <AppLink href={cancel.href} className={buttonStyles({ variant: "ghost", size: "sm" })}>
            {cancel.label}
          </AppLink>
        </div>
      </Panel>
      <MobileActionBar>
        <div className="flex w-full items-center gap-3 p-1 pl-3">
          <span className="flex min-w-0 flex-1 flex-col">
            <Text as="span" variant="body-b3" tone="tertiary">
              {price.label}
            </Text>
            <Amount cents={price.cents} currency={currency} className="text-text-primary" />
          </span>
          {submitButton(false)}
        </div>
      </MobileActionBar>
    </>
  );
}
